import { CoreInterfaces } from "./../../Models";
import * as Constants from "../../Constants/Constants";

export function uiReducer(
  state: CoreInterfaces.AppState,
  action: { type: Constants.AppStateActions; payload?: any }
): Partial<CoreInterfaces.AppState> {
  switch (action.type) {
    case Constants.AppStateActions.LoadingBlurredStateUpdate: {
      const payload = action.payload;
      const nextState = {
        ...state,
        state: {
          ...state.state,
          ...payload,
        },
      };

      return nextState;
    }
    case Constants.AppStateActions.RatesChangeMessageVisibilityUpdated: {
      const payload = action.payload as boolean;
      const nextState = {
        ...state,
        state: {
          ...state.state,
          isRatesChangeMessagesShow: payload,
        },
      };

      return nextState;
    }
    case Constants.AppStateActions.UpdateEngagementConflict: {
      const actionPayload = action.payload;
      const nextState = {
        ...state,
        showConflictUpdateDialog: actionPayload.showConflictUpdateDialog,
        isConflictOnUpdateEngagement:
          actionPayload.isConflictOnUpdateEngagement,
        lastModifiedBy: actionPayload.lastModifiedBy,
      };

      return nextState;
    }
    case Constants.AppStateActions.ChangeUnsavedFlag: {
      const nextState: CoreInterfaces.AppState = {
        ...state,
        areUnsavedChanges: false,
      };
      return nextState;
    }
    case Constants.AppStateActions.UpdateAlertBanner: {
      const payload = action.payload;
      const nextState: CoreInterfaces.AppState = {
        ...state,
        alertBanner: {
          ...state.alertBanner,
          ...payload,
        },
      };
      return nextState;
    }
    default:
      return {};
  }
}
